import { $ } from "@utils/dom";

class Clock {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.initialized = false;
    this.timezone = this.el.dataset.timezone;
    this.timeElement = $(".pb-row-contact__clock__time", this.el);
    this.date = null;

    this._onInterval = this._onInterval.bind(this);
    this._interval = null;

    this._clockHours = new ClockPart($(".pb-row-contact__clock__time__hours", this.el));
    this._clockMinutes = new ClockPart($(".pb-row-contact__clock__time__minutes", this.el));
    this._clockSeconds = new ClockPart($(".pb-row-contact__clock__time__seconds", this.el));
    this._clockMeridiem = new ClockPart($(".pb-row-contact__clock__time__meridiem", this.el));

    // merge all clock parts in an array
    this.clockParts = [this._clockHours, this._clockMinutes, this._clockSeconds, this._clockMeridiem];
  }

  init() {
    if(this.initialized) return

    // return error if missing clock elements
    if(!this._clockMinutes.el || !this._clockHours.el || !this._clockSeconds.el || !this._clockMeridiem.el) {
      console.error("Clock module: missing clock elements");
      return;
    }

    this._bindEvents();
    this._setTime();
    this.initialized = true;
  }
  destroy() {
    this._unbindEvents();
    this.clockParts.forEach(clockPart => clockPart?.destroy());
    this.el = null;
    this.emitter = null;
    this.initialized = null;
    this.timezone = null;
    this.date = null;
    this._onInterval = null;
    this._interval = null;
    this._clockHours = null;
    this._clockMinutes = null;
    this._clockSeconds = null;
    this._clockMeridiem = null;
    this._clockParts = null;
  }

  start() {}
  stop() {}

  _bindEvents() {
    this._interval = setInterval(this._onInterval, 1000);
  }
  _unbindEvents() {
    clearInterval(this._interval);
  }

  _onInterval() {
    this._setTime();
  }

  _setTime() {
    this.date = new Date();
    const options = {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: this.timezone
    };

    // get each part from date formatted : 11:11:11 AM
    const parts = this.date.toLocaleString('en', options).split(':');

    const hours = parts[0];
    const minutes = parts[1];
    const seconds = parts[2].split(' ')[0]; // get 11 from "11 AM"
    const meridiem = parts[2].split(' ')[1]; // get AM from "11 AM"

    this._clockHours.value = hours;
    this._clockMinutes.value = minutes;
    this._clockSeconds.value = seconds;
    this._clockMeridiem.value = meridiem;

    // toggle classname
    this.el.classList.toggle('--tick', this.date.getSeconds() % 2 === 0);
  }

}


class ClockPart {
  constructor(el) {
    this.el = el
  }

  destroy() {
    this.el = null;
  }

  get value() {
    return this.el.innerHTML;
  }

  set value(value) {
    this.el.innerHTML = value;
  }

}

export default Clock;
